import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'

export function activateConfiguredProviderIntegration(
  definition: BetterstartIntegrationDefinition,
  config: ResolvedBetterstartConfig
): boolean {
  let changed = false
  const emailProvider = definition.capabilities?.emailProvider
  const storageProvider = definition.capabilities?.storageProvider

  if (emailProvider && config.email.provider !== emailProvider.provider) {
    config.email.provider = emailProvider.provider
    changed = true
  }

  if (storageProvider && config.storage.provider !== storageProvider.provider) {
    config.storage.provider = storageProvider.provider
    changed = true
  }

  return changed
}
